import { useEffect, useState } from 'react';

import AssetService from '../../shared/services/AssetService';
import { LessonComponentBase } from '../models/LessonComponent';
import LessonVm from '../models/LessonVm';
import axios from 'axios';
import config from '../../shared/config';

/**
 * Hook to load a lesson by sharing link.
 */
const useLinkLesson = (linkkey: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [lesson, setLesson] = useState<LessonVm>();
  const [components, setComponents] = useState<LessonComponentBase[]>();

  useEffect(() => {
    setLoading(true);
    AssetService.getConatinerSasFromLink(linkkey)
      .then(() =>
        axios.get(`${config.CONTENT_DS}/api/public/link/lesson/${linkkey}`)
      )
      .then((response) => response.data)
      .then((data) => {
        setLesson(data.lesson);
        setComponents(data.components);
      })
      .catch((error) => setError(`${error.response?.data || error}`))
      .finally(() => setLoading(false));
  }, [linkkey]);
  return { loading, error, lesson, components };
};
export default useLinkLesson;
